import App from "./app_reducer";
import Auth from "./auth_reducer";
import Bank from "./bank_reducer";
import BusinessCategory from "./business_category_reducer";
import Consumer from "./consumer_reducer";
import Email from "./email_reducer";
import GoogleMap from "./google_map_reducer";
import Location from "./location_reducer";
import Mall from "./mall_reducer";
import Menu from "./menu_reducer";
import Notification from "./notification_reducer";
import Order from "./order_reducer";
import Preference from "./preference_reducer";
import Restaurant from "./restaurant_reducer";
import Review from "./review_reducer";
import Voucher from "./voucher_reducer";
import Wallet from "./wallet_reducer";

export default {
  App,
  Auth,
  Bank,
  BusinessCategory,
  Consumer,
  Email,
  GoogleMap,
  Location,
  Mall,
  Menu,
  Notification,
  Order,
  Preference,
  Restaurant,
  Review,
  Voucher,
  Wallet
};
